import { render } from "./LeaveComment.vue?vue&type=template&id=6dd4c63a&scoped=true"
import script from "./LeaveComment.vue?vue&type=script&lang=js"
export * from "./LeaveComment.vue?vue&type=script&lang=js"

import "./leave-comment.scss?vue&type=style&index=0&id=6dd4c63a&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd4c63a"]])

export default __exports__